<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @reload="reload"
      @openEditFileDialog="openEditFileDialog"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
        @uploadFile="uploadFileVisible = true"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <UploadFile
      :visible.sync="uploadFileVisible"
      :title="$l('dialog_title_customer_file_upload') || '上传收发货人相关文件'"
      :shipmentCustomerCode="shipmentCustomerCode"
      @reload="reload"
    />
    <EditFile
      :visible.sync="editFileOptions.visible"
      :title="$l('dialog_title_customer_file_edit') || '编辑收发货人相关文件'"
      :customerFileCode="editFileOptions.code"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import UploadFile from '../customer-upload-file'
import EditFile from '../customer-edit-file'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, UploadFile, EditFile },
  props: {
    disabled: { type: Boolean, default: false },
    shipmentCustomerCode: { type: String, default: '' },
  },
  data() {
    return {
      usePage: true,
      uploadFileVisible: false,
      editFileOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .shipmentCustomerFileListApi({
          shipmentCustomerCode: this.shipmentCustomerCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFileDialog({ customerFileCode: code }) {
      this.editFileOptions = { visible: true, code }
    },
  },
}
</script>
